import { useState, FC, ReactNode } from 'react';
import { Popover } from '@headlessui/react';
import { Placement } from '@popperjs/core';
import { usePopper } from 'react-popper';

import { InfoCircleSolidIcon } from 'components/icons/InfoCircleSolidIcon';

type PopoverProps = {
  info: string | ReactNode;
  button?: ReactNode;
  placement?: Placement;
  className?: string;
  infoClassName?: string;
  wrapperClassName?: string;
  onClick?: () => void;
};

const PopoverOnHover: FC<PopoverProps> = ({
  info,
  button,
  className,
  infoClassName,
  wrapperClassName,
  placement = 'top',
  onClick,
}) => {
  const [open, setOpen] = useState(false);
  const [referenceElement, setReferenceElement] = useState<any>(null);
  const [popperElement, setPopperElement] = useState<HTMLDivElement | null>(
    null,
  );

  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    placement,
    modifiers: [
      {
        name: 'offset',
        options: { offset: [0, 5] },
      },
    ],
  });

  return (
    <Popover className={wrapperClassName}>
      <Popover.Button
        ref={setReferenceElement}
        className={className}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        onClick={onClick}
        as="div"
      >
        {button || (
          <InfoCircleSolidIcon className="w-5 h-5 text-gray-400 hover:text-gray-900" />
        )}
      </Popover.Button>

      {open && info && (
        <Popover.Panel
          ref={setPopperElement}
          className={
            infoClassName ||
            'z-10 w-[343px] text-sm text-gray-100 bg-gray-900 p-3 ring-1 ring-black ring-opacity-5 shadow-lg rounded-lg'
          }
          style={styles.popper}
          {...attributes.popper}
          static
        >
          {info}
        </Popover.Panel>
      )}
    </Popover>
  );
};

export default PopoverOnHover;
